<div class="hover-div" [ngClass]="
    {
    'white-color': color === 'white', 'black-color': color === 'black', 'primary-color': color === 'primary', 'menu-link-color': color === 'menu',
    'small-gap': gap === 'small', 'medium-gap': gap === 'medium', 'big-gap': gap === 'big'
    }"
>
</div>
